import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Checked from '../../assets/icons/icon_checked.png';

import { MyContext } from '../../context/MyContext';
import { backIncstance } from '../../utils/commonFunctions'
const URLS = {
  LOGIN_CHECK: process.env.REACT_APP_LOGIN_CHECK_URL,
}
const PaymentSuccess = props => {

  const { user, setUser, setAlertSetting } = useContext(MyContext);

  const location = useLocation();
  const navigation = useNavigate();
  const [targetName, setTargetName] = useState('상품')
  useEffect(() => {
    const itemName = location?.state?.from_chat;
    if (itemName) {
      setTargetName(itemName)
    }
  }, [location])

  const touchAPI = async (method, url, data) => {
    try {
      const response = await backIncstance(method, url, data)
      return response
    } catch (err) {
      setAlertSetting(prev => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: '닫기'
      }));
    }

  }
  const handleLink = () => {
    navigation('/order-list')
  }

  useEffect(() => {
    const getData = async () => {
      const response = await touchAPI('GET', URLS.LOGIN_CHECK)
      if (response) {
        const resData = await response?.json();
        if (resData) {
          setUser(prev => ({
            ...prev,
            id: resData.profile_id,
            name: resData.name,
            picture_extension: resData.picture_extension,
            picture_data: resData.picture_data,
            paid: resData.paid,
            tone: resData.tone,
            start_dt: resData.start_dt,
            end_dt: resData.end_dt,
            tutor_cnt: resData.tutor_cnt,
            socra_cnt: resData.socra_cnt,
          }))
          localStorage.setItem('userInfo', JSON.stringify(resData));
        }
      }
    }
    getData();
  }, [])

  return (
    <div className="ctn-wrp flx-box st-wrp success">
      <div className="top">
        <div className="img-wrp">
          <img src={Checked} alt="" />
        </div>
      </div>
      <div className="middle">
        <p className="highlight">{`[${targetName}]`}</p>
        <p>주문이 완료되었습니다.</p>
      </div>
      <div className="bottom crs-btn" onClick={handleLink}>구매내역 보기</div>
    </div>
  )
}
export default PaymentSuccess
